import { useContext } from 'react';
import { ColorModeContext } from '../containers/App/ThemeProvider';

// Custom hook to access the theme mode and toggle function
export const useThemeMode = () => {
  return useContext(ColorModeContext);
}; 